export const errorMessages = {
  EMPTY: 'empty',
  INVALID: 'invalid',
  TOO_LONG: 'tooLong',
  TOO_SHORT: 'tooShort',
  TOO_YOUNG: 'tooYoung',
  TOO_OLD: 'tooOld',
  TOO_FEW: 'tooFew',
  TOO_MANY: 'tooMany',
  SERVICE_INVALID: 'lookUpFailed',
  TECH_ERROR: 'techError',
  IN_FLIGHT: 'inFlight',
  EXCLUDED: 'excludedPrefix',
};
